// extracted by mini-css-extract-plugin
var _1 = "ProductFrame-module_product_body___UagcI";
var _2 = "ProductFrame-module_product_main__PT9FTu";
var _3 = "ProductFrame-module_product_navbar__ZhSOJF";
export { _1 as "product_body", _2 as "product_main", _3 as "product_navbar" }
